module.exports = require("./rm.js");